import { render, staticRenderFns } from "./addYT.vue?vue&type=template&id=352ebfb2&scoped=true"
import script from "./addYT.vue?vue&type=script&lang=js"
export * from "./addYT.vue?vue&type=script&lang=js"
import style0 from "./addYT.vue?vue&type=style&index=0&id=352ebfb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352ebfb2",
  null
  
)

export default component.exports